import { useRouter } from 'next/router';

export default function useQuery() {
  const router = useRouter();
  return new URLSearchParams(router.query.toString());
}
